import organization from '@/store/modules/auth';
import settings from '@/store/modules/settings';

export const allowedLines = () => {
  return settings.state.account_type?.allowedLines[
    organization.state.organization?.accountType
  ];
};

/**
 * Filters documents based on whether the organization is a Mearsk account.
 * @param {Array} docs - The array of document objects to filter.
 * @returns {Array} - The filtered array of document objects.
 */
export const filterDocuments = (docs) => {
  if (organization.state.organization?.accountType) {
    const lines = allowedLines();
    return docs?.filter((doc) =>
      lines?.includes(
        (doc?.data &&
          (doc.data()?.line?.id || doc?.data()?.container?.line?.id)) ||
          doc?.id
      )
    );
  }

  return docs;
};
